import { render, staticRenderFns } from "./CurrencyIndex.vue?vue&type=template&id=b6538dda&scoped=true&"
import script from "./CurrencyIndex.vue?vue&type=script&lang=js&"
export * from "./CurrencyIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6538dda",
  null
  
)

export default component.exports